var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bot"},[_c('a',{attrs:{"target":"blank","href":"https://github.com/presenta-software/presenta-lib/issues"}},[_vm._v("help")]),_vm._v(" / "),_c('a',{attrs:{"target":"blank","href":"https://github.com/presenta-software/presenta-lib/discussions"}},[_vm._v("suggest")])])
}]

export { render, staticRenderFns }